<span class="spinner fa fa-spinner centered"/>
